import { createSlice } from '@reduxjs/toolkit'
import { merge } from 'components/util'
import MetricInitialization from './metric-initialization-model'
import {
  CreateMetricInitializationAsync,
  DeleteMetricInitializationAsync,
  LoadMetricInitializationsAsync,
} from './metricInitialization-thunk'
const initialState: metricInitializationSliceState = {
  metricInitialization: [],
  selected_metricInitialization: '',
  is_loading_metricInitialization: false,
  is_creating_metricInitialization: false,
  is_deleting_metricInitialization: false,
}
export interface metricInitializationSliceState {
  metricInitialization: MetricInitialization[]
  selected_metricInitialization?: string
  is_loading_metricInitialization: boolean
  is_creating_metricInitialization: boolean
  is_deleting_metricInitialization: boolean
}
export const metricInitializationSlice = createSlice({
  name: 'metricInitialization',
  initialState,
  reducers: {
    setSelectedmetricInitialization: (state, action) => {
      state.selected_metricInitialization = action.payload
    },
    clearStatemetricInitialization: (state) => {
      state.metricInitialization = []
      state.is_loading_metricInitialization = false
      state.is_creating_metricInitialization = false
      state.is_deleting_metricInitialization = false
    },
    mergemetricInitialization: (state, action) => {
      if (action.payload) {
        let payload: any = action.payload
        if (payload?.data) {
          if (!Array.isArray(payload.data)) {
            state.selected_metricInitialization = payload?.data?.id
            payload = [payload.data]
          } else {
            payload = payload.data
          }
          state.metricInitialization = merge(
            state.metricInitialization,
            payload,
          ) as any
        }
      }
    },

    add_metricInitialization: (state, action) => {
      if (action.payload) {
        state.metricInitialization = [
          ...state.metricInitialization,
          action.payload,
        ]
      }
    },
    set_metricInitialization: (state, action) => {
      let { key, value, id } = action.payload
      state.metricInitialization = state.metricInitialization.map((item) => {
        if (item && item.id === id) {
          return {
            ...item,
            [key]: value,
          }
        }
        return item
      })
    },
  },
  extraReducers: (builder) => {
    builder.addCase('LOGOUT', () => {
      return { ...initialState }
    })

    builder.addCase(LoadMetricInitializationsAsync.pending, (state) => {
      state.is_loading_metricInitialization = true
    })
    builder.addCase(
      LoadMetricInitializationsAsync.fulfilled,
      (state, action) => {
        state.is_loading_metricInitialization = false
        if (action.payload) {
          state.metricInitialization = action.payload
        }
      },
    )
    builder.addCase(LoadMetricInitializationsAsync.rejected, (state) => {
      state.is_loading_metricInitialization = false
    })
    builder.addCase(CreateMetricInitializationAsync.pending, (state) => {
      state.is_creating_metricInitialization = true
    })
    builder.addCase(CreateMetricInitializationAsync.fulfilled, (state) => {
      state.is_creating_metricInitialization = false
    })
    builder.addCase(CreateMetricInitializationAsync.rejected, (state) => {
      state.is_creating_metricInitialization = false
    })
    builder.addCase(DeleteMetricInitializationAsync.pending, (state) => {
      state.is_deleting_metricInitialization = true
    })
    builder.addCase(
      DeleteMetricInitializationAsync.fulfilled,
      (state, action) => {
        state.is_deleting_metricInitialization = false
        if (state.metricInitialization) {
          state.metricInitialization = state.metricInitialization.filter(
            (x) => action.payload.id !== x.id,
          )
        }
      },
    )
    builder.addCase(DeleteMetricInitializationAsync.rejected, (state) => {
      state.is_deleting_metricInitialization = false
    })
  },
})

export const {
  clearStatemetricInitialization,
  setSelectedmetricInitialization,
  set_metricInitialization,
  mergemetricInitialization,
  add_metricInitialization,
} = metricInitializationSlice.actions

export const get_metricInitialization =
  (id?: string) =>
  (state: {
    metricInitialization: {
      metricInitialization: MetricInitialization[]
    }
  }): MetricInitialization | null => {
    let temp = state?.metricInitialization?.metricInitialization?.find(
      (v) => v.id === id,
    )
    if (temp) {
      return temp
    }
    return state?.metricInitialization?.metricInitialization[0] || null
  }
export const get_selected_metricInitialization = (state: {
  metricInitialization: metricInitializationSliceState
}): MetricInitialization | null => {
  let id = state?.metricInitialization?.selected_metricInitialization
  let temp = state?.metricInitialization?.metricInitialization?.find(
    (v) => v.id === id,
  )
  if (temp) {
    return temp
  }
  return null
}
export const get_all_metricInitialization = (state: {
  metricInitialization: {
    metricInitialization: MetricInitialization[]
  }
}): MetricInitialization[] => {
  let temp = state?.metricInitialization?.metricInitialization
  if (temp) {
    return temp.filter((x) => !x.deleted)
  }
  return []
}
export const is_metricInitialization_busy = (state: {
  metricInitialization: metricInitializationSliceState
}) => {
  return (
    state?.metricInitialization.is_deleting_metricInitialization ||
    state?.metricInitialization.is_loading_metricInitialization ||
    state?.metricInitialization.is_creating_metricInitialization
  )
}
export const is_deleting_metricInitialization_busy = (state: {
  metricInitialization: metricInitializationSliceState
}) => {
  return state?.metricInitialization.is_deleting_metricInitialization
}
export const is_loading_metricInitialization_busy = (state: {
  metricInitialization: metricInitializationSliceState
}) => {
  return state?.metricInitialization.is_loading_metricInitialization
}
export const is_creating_metricInitialization_busy = (state: {
  metricInitialization: metricInitializationSliceState
}) => {
  return state?.metricInitialization.is_creating_metricInitialization
}

export default metricInitializationSlice.reducer
